// This client was generated by Platformatic from an OpenAPI specification.

import type { Api } from './api-types'
import type * as Types from './api-types'

// The base URL for the API. This can be overridden by calling `setBaseUrl`.
let baseUrl = ''
// The default headers to send within each request. This can be overridden by calling `setDefaultHeaders`.
let defaultHeaders = {}

function sanitizeUrl(url: string) : string {
  if (url.endsWith('/')) { return url.slice(0, -1) } else { return url }
}
export const setBaseUrl = (newUrl: string) : void => { baseUrl = sanitizeUrl(newUrl) }

export const setDefaultHeaders = (headers: Object): void => { defaultHeaders = headers }

type JSON = Record<string, unknown>
/* @ts-ignore */
function headersToJSON(headers: Headers): JSON {
  const output: JSON = {}
  headers.forEach((value, key) => {
    output[key] = value
  })
  return output
}

const _postV1Drive = async (url: string, request: Types.PostV1DriveRequest): Promise<Types.PostV1DriveResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/drive/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Drive: Api['postV1Drive'] = async (request: Types.PostV1DriveRequest): Promise<Types.PostV1DriveResponses> => {
  return await _postV1Drive(baseUrl, request)
}
const _getV1Drive = async (url: string, request: Types.GetV1DriveRequest): Promise<Types.GetV1DriveResponses> => {
  const queryParameters: (keyof Types.GetV1DriveRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/drive/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Drive: Api['getV1Drive'] = async (request: Types.GetV1DriveRequest): Promise<Types.GetV1DriveResponses> => {
  return await _getV1Drive(baseUrl, request)
}
const _getV1DriveId = async (url: string, request: Types.GetV1DriveIdRequest): Promise<Types.GetV1DriveIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/drive/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DriveId: Api['getV1DriveId'] = async (request: Types.GetV1DriveIdRequest): Promise<Types.GetV1DriveIdResponses> => {
  return await _getV1DriveId(baseUrl, request)
}
const _putV1DriveId = async (url: string, request: Types.PutV1DriveIdRequest): Promise<Types.PutV1DriveIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/drive/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DriveId: Api['putV1DriveId'] = async (request: Types.PutV1DriveIdRequest): Promise<Types.PutV1DriveIdResponses> => {
  return await _putV1DriveId(baseUrl, request)
}
const _deleteV1DriveId = async (url: string, request: Types.DeleteV1DriveIdRequest): Promise<Types.DeleteV1DriveIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/drive/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DriveId: Api['deleteV1DriveId'] = async (request: Types.DeleteV1DriveIdRequest): Promise<Types.DeleteV1DriveIdResponses> => {
  return await _deleteV1DriveId(baseUrl, request)
}
const _putV1DriveIdMoveParentDirectory = async (url: string, request: Types.PutV1DriveIdMoveParentDirectoryRequest): Promise<Types.PutV1DriveIdMoveParentDirectoryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/drive/${request['id']}/move/${request['parentDirectory']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DriveIdMoveParentDirectory: Api['putV1DriveIdMoveParentDirectory'] = async (request: Types.PutV1DriveIdMoveParentDirectoryRequest): Promise<Types.PutV1DriveIdMoveParentDirectoryResponses> => {
  return await _putV1DriveIdMoveParentDirectory(baseUrl, request)
}
const _getV1DriveActivity = async (url: string, request: Types.GetV1DriveActivityRequest): Promise<Types.GetV1DriveActivityResponses> => {
  const queryParameters: (keyof Types.GetV1DriveActivityRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/drive-activity/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DriveActivity: Api['getV1DriveActivity'] = async (request: Types.GetV1DriveActivityRequest): Promise<Types.GetV1DriveActivityResponses> => {
  return await _getV1DriveActivity(baseUrl, request)
}
const _getV1DriveActivityId = async (url: string, request: Types.GetV1DriveActivityIdRequest): Promise<Types.GetV1DriveActivityIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/drive-activity/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DriveActivityId: Api['getV1DriveActivityId'] = async (request: Types.GetV1DriveActivityIdRequest): Promise<Types.GetV1DriveActivityIdResponses> => {
  return await _getV1DriveActivityId(baseUrl, request)
}
const _postV1SharedDriveShare = async (url: string, request: Types.PostV1SharedDriveShareRequest): Promise<Types.PostV1SharedDriveShareResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/shared-drive/share`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SharedDriveShare: Api['postV1SharedDriveShare'] = async (request: Types.PostV1SharedDriveShareRequest): Promise<Types.PostV1SharedDriveShareResponses> => {
  return await _postV1SharedDriveShare(baseUrl, request)
}
const _getV1SharedDriveId = async (url: string, request: Types.GetV1SharedDriveIdRequest): Promise<Types.GetV1SharedDriveIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/shared-drive/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SharedDriveId: Api['getV1SharedDriveId'] = async (request: Types.GetV1SharedDriveIdRequest): Promise<Types.GetV1SharedDriveIdResponses> => {
  return await _getV1SharedDriveId(baseUrl, request)
}
const _getV1SharedDrive = async (url: string, request: Types.GetV1SharedDriveRequest): Promise<Types.GetV1SharedDriveResponses> => {
  const queryParameters: (keyof Types.GetV1SharedDriveRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/shared-drive/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SharedDrive: Api['getV1SharedDrive'] = async (request: Types.GetV1SharedDriveRequest): Promise<Types.GetV1SharedDriveResponses> => {
  return await _getV1SharedDrive(baseUrl, request)
}
const _postV1SharedDriveRevoke = async (url: string, request: Types.PostV1SharedDriveRevokeRequest): Promise<Types.PostV1SharedDriveRevokeResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/shared-drive/revoke`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SharedDriveRevoke: Api['postV1SharedDriveRevoke'] = async (request: Types.PostV1SharedDriveRevokeRequest): Promise<Types.PostV1SharedDriveRevokeResponses> => {
  return await _postV1SharedDriveRevoke(baseUrl, request)
}
const _getV1FileUpload = async (url: string, request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  const queryParameters: (keyof Types.GetV1FileUploadRequest)[]  = ['key', 'mimeType', 'partCount']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['file-size'] !== undefined) {
    headers['file-size'] = request['file-size']
    delete request['file-size']
  }

  const response = await fetch(`${url}/v1/file-upload/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FileUpload: Api['getV1FileUpload'] = async (request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  return await _getV1FileUpload(baseUrl, request)
}
const _postV1FileUploadMarkComplete = async (url: string, request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/file-upload/mark-complete`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1FileUploadMarkComplete: Api['postV1FileUploadMarkComplete'] = async (request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  return await _postV1FileUploadMarkComplete(baseUrl, request)
}
const _postV1DriveLocationId = async (url: string, request: Types.PostV1DriveLocationIdRequest): Promise<Types.PostV1DriveLocationIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/drive-location/${request['id']}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DriveLocationId: Api['postV1DriveLocationId'] = async (request: Types.PostV1DriveLocationIdRequest): Promise<Types.PostV1DriveLocationIdResponses> => {
  return await _postV1DriveLocationId(baseUrl, request)
}
const _getV1DriveLocationId = async (url: string, request: Types.GetV1DriveLocationIdRequest): Promise<Types.GetV1DriveLocationIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/drive-location/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DriveLocationId: Api['getV1DriveLocationId'] = async (request: Types.GetV1DriveLocationIdRequest): Promise<Types.GetV1DriveLocationIdResponses> => {
  return await _getV1DriveLocationId(baseUrl, request)
}
const _putV1DriveLocationId = async (url: string, request: Types.PutV1DriveLocationIdRequest): Promise<Types.PutV1DriveLocationIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/drive-location/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DriveLocationId: Api['putV1DriveLocationId'] = async (request: Types.PutV1DriveLocationIdRequest): Promise<Types.PutV1DriveLocationIdResponses> => {
  return await _putV1DriveLocationId(baseUrl, request)
}
type BuildOptions = {
  headers?: Object
}
export default function build (url: string, options?: BuildOptions) {
  url = sanitizeUrl(url)
  if (options?.headers) {
    defaultHeaders = options.headers
  }
  return {
    postV1Drive: _postV1Drive.bind(url, ...arguments),
    getV1Drive: _getV1Drive.bind(url, ...arguments),
    getV1DriveId: _getV1DriveId.bind(url, ...arguments),
    putV1DriveId: _putV1DriveId.bind(url, ...arguments),
    deleteV1DriveId: _deleteV1DriveId.bind(url, ...arguments),
    putV1DriveIdMoveParentDirectory: _putV1DriveIdMoveParentDirectory.bind(url, ...arguments),
    getV1DriveActivity: _getV1DriveActivity.bind(url, ...arguments),
    getV1DriveActivityId: _getV1DriveActivityId.bind(url, ...arguments),
    postV1SharedDriveShare: _postV1SharedDriveShare.bind(url, ...arguments),
    getV1SharedDriveId: _getV1SharedDriveId.bind(url, ...arguments),
    getV1SharedDrive: _getV1SharedDrive.bind(url, ...arguments),
    postV1SharedDriveRevoke: _postV1SharedDriveRevoke.bind(url, ...arguments),
    getV1FileUpload: _getV1FileUpload.bind(url, ...arguments),
    postV1FileUploadMarkComplete: _postV1FileUploadMarkComplete.bind(url, ...arguments),
    postV1DriveLocationId: _postV1DriveLocationId.bind(url, ...arguments),
    getV1DriveLocationId: _getV1DriveLocationId.bind(url, ...arguments),
    putV1DriveLocationId: _putV1DriveLocationId.bind(url, ...arguments)
  }
}